var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"opacity":"0.54","fill-rule":"evenodd","clip-rule":"evenodd","d":"M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z"}})}
var staticRenderFns = []

export { render, staticRenderFns }